/* CAUTION, THIS FILE IS AUTO-GENERATED */
/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withIconFlavour } from '../withIconFlavour';

const IconCoreEdit = ({ size = 16, className = '', ...props }) => (
  <svg
    {...props}
    className={className}
    width={size}
    height={size}
    viewBox="0 0 16 16"
  >
    <path
      fill="currentColor"
      d="M15.303 3.899L12.219.815a.514.514 0 0 0-.707 0L3.196 9.134c-.165.197-.447.405-.526.674L.739 14.64a.5.5 0 0 0 .651.649l5.137-2.054c.096-.038.395-.244.461-.311l8.316-8.319a.5.5 0 0 0 0-.707zM3.58 10.225l2.223 2.223-2.549 1.018-.693-.693 1.019-2.549z"
    />
  </svg>
);

IconCoreEdit.displayName = 'IconCoreEdit';

IconCoreEdit.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

export default withIconFlavour(IconCoreEdit);
IconCoreEdit.displayName = 'IconCoreEdit';
